import type * as React from "react";
import type { StackProps, StackState } from "./Stack.types";
import { getIntrinsicElementProps, slot } from "@fluentui/react-components";

export const useStack = (
  props: StackProps,
  ref: React.Ref<HTMLDivElement>
): StackState => {
  const root = slot.always(getIntrinsicElementProps("div", { ...props, ref }), {
    elementType: "div",
  });

  const inner = slot.always(props.inner, {
    elementType: "div",
  });

  const state = {
    ...props,
    components: { root: "div", inner: "div" },
    root,
    inner,
  } as StackState;

  return state;
};
